// extracted by mini-css-extract-plugin
export default {"badgeContainer":"NotificationBadge_badgeContainer__iaMGV","icon":"NotificationBadge_icon__fpC20","badge":"NotificationBadge_badge__hGLSo"};